<template>
  <v-container fluid class="px-8">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-file-upload" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">Nova Importação</div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-importador-dados"
                color="success"
                min-width="100"
                style="float: right"
                class="mr-0 mt-5"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import ImportadorDadosService from '@/services/ImportadorDadosService';

  export default {
    components: {
      Parametros: () => import('@/components/importadorDados/Parametros.vue')
    },

    data: () => ({
      loading: false
    }),

    mounted() {
      this.$store.dispatch('clearImportadorDados');
    },

    methods: {
      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        ImportadorDadosService.salvar(data)
          .then(() => {
            this.$toast.success('Importação criada com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Importador de Dados Histórico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao criar importação.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
